import { ISpaceSetting } from 'modules/security/spaces/interfaces';
import { ApiClientService, EntityApiService } from 'modules/common/service';

class SpaceService extends EntityApiService<ISpaceSetting> {
  mySpaces = () => this.handleResponse(ApiClientService.get(this.getPath('/spaces'), {}));

  changeSpaceToken = (space: string, token: string, refresh: string, isAdmin?: boolean) => {
    return ApiClientService.post(
      this.getPath('/auth/refresh-token'),
      { space, token, refresh, isAdmin },
      {
        ignoreSpace: true,
      },
    );
  };
}

export default new SpaceService('/ms-auth/api');
